import { Component, ElementRef, inject, OnInit } from '@angular/core';

import { GetUserId, isMobileView, RRuleTranslator } from '@core/utils';
import { ApprovedStatus, InstructorType, NotificationType, SocketEvents } from '@core/enums';
import { NgSelectModule } from '@ng-select/ng-select';
import { DefaultImageDirective } from '@shared/directives';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRef } from '@ngneat/dialog';
import { CoursesComposition } from '@shared/compositions';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AlertMessageComponent, BadgeComponent, ButtonComponent, DynamicTabsComponent, IconComponent, TabDirective } from '@shared/components/ui';
import { CourseInstructorComponent } from './course-instructor/course-instructor.component';
import { CourseParticipantsComponent } from './course-participants/course-participants.component';
import { CourseRoomComponent } from './course-room/course-room.component';
import { CourseTaskComponent } from './course-task/course-task.component';
import { FriendlyDatePipe, HumanizePipe, TruncateTextPipe } from '@shared/pipes';

@UntilDestroy()
@Component({
  selector: 'app-course-details',
  imports: [
    IconComponent,
    ButtonComponent,
    NgSelectModule,
    ReactiveFormsModule,
    TranslateModule,
    BadgeComponent,
    DynamicTabsComponent,
    TabDirective,
    CourseInstructorComponent,
    CourseParticipantsComponent,
    CourseRoomComponent,
    CourseTaskComponent,
    NgxSkeletonLoaderModule,
    DefaultImageDirective,
    HumanizePipe,
    TruncateTextPipe,
    AlertMessageComponent,
    FriendlyDatePipe,
  ],
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.scss'],
})
export class CourseDetailsComponent extends CoursesComposition implements OnInit {
  currentTabRoute = '';
  protected readonly isMobileView = isMobileView;
  protected readonly InstructorType = InstructorType;
  private readonly _elRef = inject(ElementRef);

  constructor() {
    super();
    if (!isMobileView()) {
      this._dialogRef = inject(DialogRef);
    }
  }

  get getRecurrenceInfo() {
    if (!this.course?.recurrence) return '';

    const rruleTranslator = new RRuleTranslator(this._translateService);
    return rruleTranslator.translateRRule(this.course?.recurrence);
  }

  get isUserInvited(): boolean {
    if (this.course && this.course.approvedStatus === ApprovedStatus.Approved && this.course.author !== GetUserId()) {
      const invited = this.unApprovedCourseUsers.find((user) => user.id === GetUserId());
      return !!invited;
    }

    return false;
  }

  ngOnInit() {
    const courseId = this._dialogRef?.data?.courseId;
    this.currentDate = this._dialogRef?.data?.currentCourseDate;

    if (courseId) {
      this._fetchAllCourseDetails(courseId);

      this._socketService
        .fromEvent(SocketEvents.GetNotification)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (data: NotificationType) => {
            if (data === NotificationType.Course) {
              this._fetchAllCourseDetails(courseId);
            }
          },
        });
    }
  }
}
